import axios, { AxiosError } from 'axios';
import { VriAPIResponse, VriAPIResult } from '../types';
import { getErrorMessage } from '../lib/error-handling';
import END_POINT from '../config/endpoints.constants';

export interface SignupOptions {
    email: string;
    password?: string;
    firstName: string;
    lastName: string;
    smsPhoneNumber: string;
    roleId: string;
    applicationName: string;
    recaptchaToken?: string | null;
}

export interface SignupResponse extends VriAPIResponse {}

export interface SignupResult extends VriAPIResult {
    message: string;
}

export async function signup(options: SignupOptions): Promise<SignupResult> {
    const result = {} as SignupResult;
    try {
        const { data: responseData } = await axios.post<SignupResponse>(
            END_POINT.CREATE_CUSTOMER,
            options,
            {
                headers: {
                    'App-Name': 'userapp',
                    'App-Source': 'userapp',
                },
            },
        );

        if (responseData.code === 1) {
            result.error = responseData.message;
        } else {
            result.message = responseData.message;
        }
    } catch (error) {
        result.error = getErrorMessage(error as AxiosError);
    }
    return result;
}
